import { APP_PAGE_URL } from "utils/env-management"

export function getPageUrl(path: string) {
    return `${APP_PAGE_URL}${path}`
}
